import React from "react"
import {HandsfreeCameraDeviceOverviewContext} from "./context/HandsfreeCameraDeviceOverviewContext";
import CameraDeviceOverview from "./CameraDeviceOverview";

const HandsfreeCameraDeviceOverview = (props) => {
    return <CameraDeviceOverview {...props} deviceContext={HandsfreeCameraDeviceOverviewContext}/>;
}

export default HandsfreeCameraDeviceOverview



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/HandsfreeCameraDeviceOverview.js